





















import Vue from 'vue';
import DocumentView from './DocumentView.vue';
import Errors from '@/components/common/form/Errors.vue';
export default Vue.extend({
    components: { DocumentView, Errors },
    props: {
        document: {
            type: Object,
            required: true,
        },
        progress: {
            type: Number,
            required: false,
            default: null,
        },
    },
    computed: {
        showProgress() {
            return this.progress && this.progress >= 0;
        },
        progressPercent() {
            return this.progress > 100 ? '100%' : (this.progress || 100) + '%';
        },
    },
});
